import { inject, Injectable, signal } from '@angular/core';
import { ViewTripHeader } from '@com-delta-idp/mnx-capability-trip-management-ui';
import {
  DashboardResponse,
  MyTripAem,
  UserDataService
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { MostUpcomingTrip } from '../models/interface';

@Injectable({
  providedIn: 'root'
})
export class MyTripBaseFacadeService {
  spinner = signal<boolean>(false);
  myTripStaticContent = signal<MyTripAem>({} as MyTripAem);
  adaptedTripDetails = signal<ViewTripHeader | null>(null);
  displayTripDetails = signal<boolean>(false);
  displayFindTripLink = signal<boolean>(true);
  displayErrorMessage = signal<boolean>(false);
  userSessionData = signal<DashboardResponse | null>(null);
  showMytrip = signal<boolean>(false);
  showAlert = signal<boolean>(false);
  mostRecentTripsData = signal<MostUpcomingTrip>({} as MostUpcomingTrip);

  protected userData = inject(UserDataService);
}
